const get = () =>
    fetch('https://aieseccolombia.org:8123/universities')
    .then(res => res.json())

const universitiesService = {
    get,
};

export default universitiesService;